import styled from 'styled-components';

// Takes over the sizing the Orders header gives its links, so the button lays out
// exactly as before; the header's `a` / `button` rules would otherwise size the
// link and the tooltip buttons against this wrapper.
export const BookADriverButtonWrap = styled.div`
  position: relative;
  display: flex;

  @media (max-width: 767px) {
    margin: 8px;
    flex: 0 0 auto;
  }
  @media (max-width: 650px) {
    flex: calc(50% - 16px);
    max-width: calc(50% - 16px);
  }
  @media (max-width: 470px) {
    margin: 4px;
    flex: calc(100% - 8px);
    max-width: calc(100% - 8px);
  }

  && > a {
    margin: 0;
    flex: 1 1 auto;
    max-width: 100%;
  }

  && button {
    margin: 0;
    flex: 0 0 auto;
    max-width: none;
  }
`;

export const BookADriverNewPill = styled.span`
  &&& {
    display: inline-block;
    margin-left: 8px;
    padding: 2px 7px;
    border-radius: 999px;
    background: #fff;
    color: #ff2d38;
    font-size: 10px;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: 0.04em;
    vertical-align: middle;
  }
`;

export const BookADriverTooltip = styled.div`
  position: absolute;
  top: calc(100% + 14px);
  right: 0;
  z-index: 10;
  width: 320px;
  max-width: calc(100vw - 32px);
  padding: 16px 18px;
  border-radius: 10px;
  background: #1a1a1a;
  color: #fff;
  font-family: 'Poppins', sans-serif;
  text-align: left;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);

  &::before {
    position: absolute;
    top: -6px;
    right: 36px;
    width: 12px;
    height: 12px;
    background: #1a1a1a;
    transform: rotate(45deg);
    content: '';
  }

  /* Below 651px the button wraps to the left of its own row, so a right-aligned
     tooltip would run off the left edge of the screen. */
  @media (max-width: 650px) {
    right: auto;
    left: 0;

    &::before {
      right: auto;
      left: 36px;
    }
  }
`;

export const BookADriverTooltipTitle = styled.div`
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  margin-bottom: 4px;
`;

export const BookADriverTooltipBody = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: #cfcfd6;
`;

export const BookADriverTooltipActions = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 12px;
`;

export const BookADriverTooltipPrimary = styled.button`
  padding: 7px 14px;
  border: none;
  border-radius: 999px;
  background: #ff2d38;
  color: #fff;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
`;

export const BookADriverTooltipSecondary = styled.button`
  padding: 0;
  border: none;
  background: none;
  color: #9a9aa3;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  cursor: pointer;
`;
